var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"pb-4 fill-height"},[(_vm.title !== '')?_c('h2',{staticClass:"justify-center card-title pt-4"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('v-card-text',[_c('v-row',{staticClass:"d-flex flex-column flex-sm-row justify-space-around fill-height align-center"},[_vm._t("content")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }